import externalRouter from '../../utils/externalRouter';

export default (route, { hash }) => {
  return externalRouter.parse(route, hash);
};
